import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
 // import {NotificationManager} from "react-notifications";
import {useForm} from "react-hook-form";
//
// import {
//   hideMessage, resetPasswordDidNotJustResetPW,
//   showAuthLoader,
//   userSignIn,
// } from 'actions/Auth';
// import nprogress from "nprogress";
import {resetPasswordAction, resetPasswordSetIntialValues} from "../actions";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"

var pjson = require('../../package.json'); //to display version number

const ResetPasswordForm = (props) => {

    const {authUser} = useSelector(({auth}) => auth);

  const isVoluntaryChange = authUser? !authUser.user.needs_password_reset : null;
  const { register, handleSubmit, errors } = useForm();


  const [usernameInput, setUsernameInput] = useState(null);
  const [emailInput, setEmailInput] = useState(null);
  const dispatch = useDispatch();
  const {token} = useSelector(({auth}) => auth);
  const {didJustResetPW} = useSelector(({auth}) => auth.appMisc);
  const {loader} = useSelector(({auth}) => auth);

  const onSubmit = data => dispatch(resetPasswordAction({"username": data.usernameInput, "email": data.emailInput}));

  useEffect(() => {
    //stop the page loader
    // nprogress.done();

    // console.log("TOKEN CHECK. TOKEN IS", token, "local:", localStorage.getItem("token"));
    // console.log("DidJustResetPW Check", didJustResetPW);
    //console.log("REFRESH TOKEN CHECK. REFRESH TOKEN IS", refreshToken, "local:", localStorage.getItem("refreshToken"))
    //if there is a token set (if user is logged in), redirect to home page
    //TODO: issue where if the user is logged in (has a token), the page won't redirect
    if (didJustResetPW) {
      dispatch(resetPasswordSetIntialValues()); //reset the state to default rest password values
      props.history.push('/signin'); //redirect to the singin page
    }
  }, [props.history, dispatch, errors, didJustResetPW]);

  /*  jfd*******************************
   *   Form validation
       ********************************** */

  // console.log("Resetting password.  Is this a voluntary reset: ", isVoluntaryChange);
  const subTitle = isVoluntaryChange ?  <IntlMessages id="appModule.resetPassword.details"/>: <IntlMessages id="appModule.resetPassword.details"/>;

  return (
      <React.Fragment>
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
      <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
              <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
            </a>
          </div>

        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1><IntlMessages id="appModule.resetPassword.title"/></h1>
            <h4>{subTitle}</h4>
              {/*<ol>*/}
              {/*    <li>Enter the required information</li>*/}
              {/*    <li>You will be sent a temporary password</li>*/}
              {/*    <li>Login wiith temporary password</li>*/}
              {/*    <li>You will be guided to set a new password</li>*/}
              {/*</ol>*/}
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>
                <TextField
                    type="text"
                    id="usernameInput"
                    name="usernameInput"
                    required
                    error={!!errors.usernameInput}
                  label={<IntlMessages id="appModule.resetPassword.username"/>}
                  fullWidth
                  onChange={(event) => setUsernameInput(event.target.value)}
                  margin="normal"
                  className="mt-1 my-sm-3"
                    inputRef={register({
                      required: "This field is required." ,

                    })}
                    helperText={errors.usernameInput?.message}
                />
                <TextField
                  type="text"
                  id="emailInput"
                  name="emailInput"
                  error={!!errors.emailInput}
                  required
                  label={<IntlMessages id="appModule.resetPassword.email"/>}
                  fullWidth
                  // onChange={(event) => setNewPasswordConfirm(event.target.value)}
                  margin="normal"
                  className="mt-1 my-sm-3"
                  // onBlur={() => validatePasswordsMatch()}
                  inputRef={register({
                    required: "This field is required." ,

                  })}
                  helperText={errors.emailInput?.message}
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button onClick={handleSubmit(onSubmit)}
                          disabled={!!errors.emailInput || !!errors.usernameInput }
                          variant="contained" color="primary">
                    <IntlMessages id="appModule.resetPassword.submit"/>
                  </Button>

                  {token && //If user is logged in, they can go back to the dashboard.
                    <Link to="/board/dashboard">
                      <IntlMessages id="form.goBackHome"/>
                    </Link>
                  }

                    {!token && //If user is not logged in, they can go back to the signin.
                    <Link to="/signin">
                        <IntlMessages id="form.goSignIn"/>
                    </Link>
                    }

                </div>

              </fieldset>
            </form>
          </div>
          <div id={"version"}> v. {`${pjson.version}`}</div>
        </div>

      </div>


      {
        loader &&
        <div className="loader-view">
          <CircularProgress/>
        </div>
      }

    </div>
      </React.Fragment>
  );
};


export default ResetPasswordForm;
